import { Injectable } from '@angular/core';
var TabsetConfig = (function () {
    function TabsetConfig() {
        /** provides default navigation context class: 'tabs' or 'pills' */
        this.type = 'tabs';
    }
    TabsetConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    TabsetConfig.ctorParameters = function () { return []; };
    return TabsetConfig;
}());
export { TabsetConfig };
//# sourceMappingURL=tabset.config.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/tabs/tabset.config.js
// module id = ../../../../ngx-bootstrap/tabs/tabset.config.js
// module chunks = 4